import { render, staticRenderFns } from "./SharePositionSurvey.vue?vue&type=template&id=c06e058c&scoped=true&"
import script from "./SharePositionSurvey.vue?vue&type=script&lang=js&"
export * from "./SharePositionSurvey.vue?vue&type=script&lang=js&"
import style0 from "./SharePositionSurvey.vue?vue&type=style&index=0&id=c06e058c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e058c",
  null
  
)

export default component.exports